import React from 'react';
import { useDispatch } from 'react-redux';
import { setPendingUpload } from '@/store/upload/uploadSlice';
import Button from '../../templates/button/Button';
import Modal from '../../templates/modal/Modal';
import * as S from './ModalEmptyPhoto.styles';

import type { PodFrameBuilderElement } from '@/types/pod-frame-builder';

type ModalEmptyPhotoProps = {
  openModal?: boolean;
  onClose: () => void;
  setIgnoreImage: (value: boolean) => void;
  imageRequired: boolean;
};

const missingFramePosition = (arr: { position: number }[]) => {
  const s = new Set(arr.map((x) => x.position));
  for (let i = 0; ; i++) {
    if (!s.has(i)) return i;
  }
};

const ModalEmptyPhoto: React.FC<ModalEmptyPhotoProps> = ({
  openModal,
  onClose,
  setIgnoreImage,
  imageRequired,
}) => {
  const dispatch = useDispatch();
  const modalText = imageRequired
    ? "Please upload a photo before adding this item to your cart. Did we mention it's free?"
    : "Do you want to include a free photo with your item? Did we mention it's free?";

  const handleUpload = () => {
    const podEl = document.querySelector<PodFrameBuilderElement>('pod-frame-builder');
    if (!podEl) {
      document.getElementById('upload-field')?.click();
      return;
    }

    const pos = missingFramePosition(podEl.getImages());
    podEl.edit(pos);
  };

  return (
    <Modal
      open={openModal}
      onClose={onClose}
      onClickIcon={onClose}
      aria-labelledby="emptyPhotoModalTitle"
      aria-describedby="emptyPhotoModalDesc"
    >
      <S.Wrapper>
        <S.Heading id="emptyPhotoModalTitle">Need a photo?</S.Heading>
        <S.Text id="emptyPhotoModalDesc">{modalText}</S.Text>
        <S.ContentButton>
          {!imageRequired && (
            <Button
              color="primary"
              format="outlined"
              title="That's Ok"
              onClick={() => {
                setIgnoreImage(true);
                onClose();
              }}
            />
          )}
          <Button
            color="primary"
            format="contained"
            title="Upload"
            onClick={() => {
              dispatch(setPendingUpload(false));
              handleUpload();
              onClose();
            }}
          />
        </S.ContentButton>
      </S.Wrapper>
    </Modal>
  );
};

export default ModalEmptyPhoto;
